import React, { useEffect } from "react";

const Logo: React.FC = () => {
  return (
    <svg
      width="141"
      height="29"
      viewBox="0 0 141 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1905_3519)">
        <path
          d="M0 18.7037V18.4199C0 12.1054 3.61842 8.73535 7.76895 8.73535C10.5715 8.73535 12.2388 9.91784 13.303 11.8216V9.232H19.653V27.7853H13.303V24.829C12.7874 25.8619 11.9918 26.7289 11.007 27.3311C10.0221 27.9333 8.88778 28.2464 7.73348 28.2346C3.61842 28.2109 0 25.1247 0 18.7037ZM13.4804 18.5973V18.3135C13.4804 15.0853 12.1323 13.5244 10.0039 13.5244C7.76895 13.5244 6.45639 15.1208 6.45639 18.349V18.6328C6.45639 21.7546 7.80443 23.3627 9.89743 23.3627C11.9904 23.3627 13.4804 21.7546 13.4804 18.5973Z"
          fill="#121212"
        />
        <path
          d="M23.7676 9.23199H30.1175V12.9214C31.3 10.1543 33.2393 8.94819 36.1128 8.98367V14.8961C32.246 14.7897 30.1175 15.9958 30.1175 18.9757V27.7852H23.7676V9.23199Z"
          fill="#121212"
        />
        <path
          d="M40.435 13.5599H37.8809V9.23197H40.435V5.36523H46.7791V9.23197H50.1847V13.5599H46.7791V27.7852H40.435V13.5599Z"
          fill="#121212"
        />
        <path
          d="M51.3613 18.7392V18.4554C51.3613 12.4957 55.7957 8.73535 61.4125 8.73535C66.4854 8.73535 70.8724 11.6443 70.8724 18.3135V19.9808H57.7822C57.9596 22.4286 59.3786 23.8476 61.649 23.8476C63.742 23.8476 64.6052 22.8897 64.8772 21.6481H70.8369C70.2457 25.8341 67.0411 28.211 61.4361 28.211C55.6183 28.211 51.3613 24.8054 51.3613 18.7392ZM64.6643 16.3742C64.5579 14.1393 63.4818 12.8977 61.4007 12.8977C59.485 12.8977 58.1725 14.1393 57.8532 16.3742H64.6643Z"
          fill="#121212"
        />
        <path
          d="M75.0056 13.5599H72.6406V9.23203H75.0056V7.6002C75.0056 2.98849 77.8791 0.789062 82.2779 0.789062C83.2604 0.792311 84.2382 0.923487 85.1868 1.17928V5.82647C84.6233 5.6564 84.0372 5.57268 83.4486 5.57814C81.9586 5.57814 81.3201 6.39406 81.3201 7.6002V9.23203H85.0804V13.5599H81.3201V27.7853H75.0056V13.5599Z"
          fill="#121212"
        />
        <path
          d="M86.4297 18.7037V18.4199C86.4297 12.1054 90.0481 8.73535 94.1986 8.73535C97.0011 8.73535 98.6684 9.91784 99.7327 11.8216V9.232H106.083V27.7853H99.7327V24.829C99.2171 25.8619 98.4215 26.7289 97.4366 27.3311C96.4518 27.9333 95.3175 28.2464 94.1632 28.2346C90.0481 28.2109 86.4297 25.1247 86.4297 18.7037ZM99.9101 18.5973V18.3135C99.9101 15.0853 98.562 13.5244 96.4336 13.5244C94.1986 13.5244 92.8861 15.1208 92.8861 18.349V18.6328C92.8861 21.7546 94.2341 23.3627 96.3271 23.3627C98.4201 23.3627 99.9219 21.7546 99.9219 18.5973H99.9101Z"
          fill="#121212"
        />
        <path
          d="M108.434 18.7392V18.4554C108.434 12.2828 112.868 8.73535 118.331 8.73535C122.872 8.73535 127.058 10.7219 127.413 16.3624H121.453C121.169 14.6241 120.318 13.6663 118.497 13.6663C116.262 13.6663 114.949 15.2627 114.949 18.3963V18.6801C114.949 21.9083 116.191 23.5756 118.603 23.5756C120.377 23.5756 121.618 22.5113 121.831 20.4893H127.543C127.365 25.1719 124.208 28.2228 118.213 28.2228C112.655 28.2109 108.434 24.9828 108.434 18.7392Z"
          fill="#121212"
        />
        <path
          d="M131.257 13.5599H128.703V9.23197H131.257V5.36523H137.613V9.23197H141.013V13.5599H137.613V27.7852H131.257V13.5599Z"
          fill="#121212"
        />
      </g>
      <defs>
        <clipPath id="clip0_1905_3519">
          <rect
            width="141"
            height="27.4219"
            fill="white"
            transform="translate(0 0.789062)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Logo;
